<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Webová aplikace pro zobrazení zákaznických provozoven a interních informací o technicích
        a probíhajících zásazích u zákazníků s napojením na Google mapy. Aplikace byla původně
        vyvíjena pouze pro intranet, ovšem poté byla přizpůsobena i pro zobrazení zákaznických
        provozoven návštěvníkům firemního webu.
      </p>
      <p>
        Aplikace umožňuje provádět se zobrazenými provozovnami různé akce, jako např. změnu umístění
        provozovny táhnutím a puštěním značky, zobrazení informací o provozovnách, potvrzení lokačních informací,
        vyhledávání tras, vyhledávání provozoven podle názvu a další.
      </p>
      <p>
        Zobrazení provozoven na mapách je možno si prohlédnout
        <a href="//septim.cz/cs/spolecnost/reference" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>zde</span>
        </a>.
      </p>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "Infomap",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'Infomapa provozoven a údajů o technické správě',
        images: [
          {
            src: '/img/refs/infomap/01.png',
            description: 'Infomapa v interním systému',
            alt: ''
          },
          {
            src: '/img/refs/infomap/02.png',
            description: 'Zobrazení infomapy pro zákazníky',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 1px;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>
